import { useEffect, useState } from "react";

import { getPublicAliasBindingByAlias } from "../services/aliases";

const regex = /[a-zA-Z]{1}[a-zA-Z0-9_\-]{4,31}/g;
const useCheckAliasesAvailability = () => {
    const [alias, setAlias] = useState("");
    const [result, setResult] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState(false);
    const [validationErr, setValidationErr] = useState(false);

    useEffect(() => {
        (async () => {
            let started = Date.now();
            const val = alias.match(regex);
            if(val === null || val[0].length !== alias.length){
                setValidationErr(true)
            }else{
                setIsLoading(true);
                setValidationErr(false)
                const { aliasBinding, err } = await getPublicAliasBindingByAlias({
                    alias
                });
                let useSetTimeout = Date.now() - started < 1000 ? 1000 : 0;
                setTimeout(() => {
                    setIsLoading(false);
                }, useSetTimeout);
                setResult(aliasBinding === null);
            }
        })()
    }, [alias]);

    return [result, isLoading, validationErr, setAlias] as [boolean, boolean, boolean, any]
};
export default useCheckAliasesAvailability
